// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
/* global __webpack_nonce__ */

import App from 'core/src/base/app';
// Extend global SS.events object with backbone events
SS.events = {};
_.extend(SS.events, Backbone.Events);
// Kick off our app
App.initialize();

// Add a nonce to all webpack generated scripts
// eslint-disable-next-line no-global-assign
__webpack_nonce__ = window.SS.serverBootstrap.nonce;
